import React from 'react';
import { Text } from '@lifeomic/chroma-react/components/Text';
import { Theme, makeStyles } from '@lifeomic/chroma-react/styles';
import { useIntl } from 'react-intl';
import { getColorByStatus } from '../../../util/graphUtils';
import { messages } from '../constants';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'space-around',
    alignContent: 'center',
    width: '70%',
    margin: 'auto',
    flexDirection: 'row',
  },
  badgeRoot: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  badgeLabel: {
    marginLeft: theme.spacing(1),
  },
  circle: ({ color }: { color?: string }) => ({
    width: theme.pxToRem(12),
    height: theme.pxToRem(12),
    borderRadius: '50%',
    backgroundColor: color,
  }),
}));

const LegendItem = ({ color, label }: { color: string; label: string }) => {
  const styles = useStyles({ color });

  return (
    <div className={styles.badgeRoot}>
      <div className={styles.circle} />
      <Text className={styles.badgeLabel}>{label}</Text>
    </div>
  );
};

export const Legend = () => {
  const styles = useStyles({});
  const { formatMessage } = useIntl();

  return (
    <div>
      <div className={styles.root}>
        <LegendItem
          color={getColorByStatus('in-range')}
          label={formatMessage(messages.inRange)}
        />
        <LegendItem
          color={getColorByStatus('attention')}
          label={formatMessage(messages.outOfRange)}
        />
      </div>
    </div>
  );
};
